import { PASS_VERIFY_PATH, ROUTE_MAP } from "../constants/routes";

export const getRouteLang = () => {
    const lang = localStorage.getItem("userLang") || "pl";
    return lang === "pl" ? "pl" : "en";
};

/** Ścieżka bieżącego języka dla klucza trasy, z podmianą :param. */
export const localizedPath = (routeKey, params = {}) => {
    const route = ROUTE_MAP[routeKey];
    if (!route) {
        // eslint-disable-next-line no-console
        console.warn(`Nieznany klucz trasy: ${routeKey}`);
        return routeKey;
    }
    let path = route[getRouteLang()] || route.en;
    Object.entries(params).forEach(([key, value]) => {
        path = path.replace(`:${key}`, encodeURIComponent(value));
    });
    return path;
};

/** Wzorzec ścieżki (z :param) do rejestracji w <Route path>. */
export const routePath = (routeKey) => {
    const route = ROUTE_MAP[routeKey];
    return route ? route[getRouteLang()] || route.en : routeKey;
};

/**
 * PEŁNY adres do zakodowania w kodzie QR przepustki.
 *
 * W kodzie QR jest LINK, nie sam token: gość okazuje telefon albo wydruk, a osoba sprawdzająca
 * skanuje go ZWYKŁYM aparatem — ma od razu wylądować na wyniku weryfikacji, a nie zobaczyć
 * bezużyteczny ciąg hex. Strona pod tym adresem jest za logowaniem (ProtectedRoute), bo token
 * jest poświadczeniem przepustki, a nie danymi publicznymi.
 *
 * Bazą jest origin bieżącej strony — ten sam host, z którego korzysta gość i obsługa, więc kod
 * działa tak samo w dev (localhost:3001) i na produkcji, bez osobnej konfiguracji na froncie.
 * (W PDF ten sam adres składa serwer z App:PublicBaseUrl — tam origin przeglądarki nie istnieje.)
 */
export const passVerifyUrl = (token) =>
    `${window.location.origin}${PASS_VERIFY_PATH}/${encodeURIComponent(token)}`;
